






























import { Component, Vue } from "vue-property-decorator";
import { getId, getRouteName, setRouteName } from '@/config/cookies'
import { getOrderInfo, getPurseOrderInfo, delOrder } from "@/api/factory";
import { bandCar } from '@/api/interface'
import { getOrder } from "@/api/interface";
import QRCode from "qrcodejs2";
import BARCode from 'jsbarcode';
import $ from "jquery";
@Component
export default class extends Vue {
    private orderId: any = ''
    private type: any = ''
    private form: any = ''
    private isLoading: boolean = false
    
    private onRefresh() {
      setTimeout(() => {
        this.getOrder()
        this.$toast('刷新成功');
        this.isLoading = false;
      }, 1000);
    }

    private onSubmit() {

    }
    private createBarcode() {
        BARCode("#barcode", this.form.str_no, {
        // format: "pharmacode",
        lineColor: "#333",
        width:2.6,
        height:40,
        displayValue: false,
        marginBottom: 30
        });
    }
    private createQrcode(width: number, height: number) {
        $('#qrcode').html('')
        var qrcode = new QRCode(document.getElementById("qrcode"), {
        text: this.form.str_no,
        width: width,
        height: height,
        correctLevel : QRCode.CorrectLevel.L
        });
    }
    private mounted() {
        this.orderId = this.$route.query.orderId;
        this.type = this.$route.query.type;
        this.getOrder();
    }
    private async getOrder() {
      const form: getOrder = {
        openId: getId(),
        orderId: this.orderId
      };
      let res: any = ''
      if(this.type == 1) {
        res = await getOrderInfo(form);
      }else {
        res = await getPurseOrderInfo(form);
      }
      this.isLoading = false;
      if (res.status) {
        if(res.data.data.status == -1) {
          this.$notify({ type: "danger", message: '订单不存在' });
          setTimeout(() => {
            // @ts-ignore
          WeixinJSBridge.invoke("closeWindow", {}, function(res: any) {});
          }, 1000)
          return
        }
        this.form = res.data.data;
        this.createQrcode(200,200);
        this.createBarcode()
      } else {
        this.$notify({ type: "danger", message: res.info });
      }
  }
}
